import React from "react";
import "react-calendar/dist/Calendar.css";
import HouseKeepingCharterTable from "./HouseKeepingCharterTable";
import { connect } from "react-redux";

function HouseKeepingCharter(props) {
  const hotelId = props.data.hotelId;

  return (
    <div className="houseKeepingCharterWrapper">
      {/* <div className="hkTableWrapper"> */}
      <HouseKeepingCharterTable selectedLanguage={props.selectedLanguage} />
      {/* </div> */}
    </div>
  );
}

function mapStateToProps(state) {
  return { data: state.auth.selectedHotel };
}
export default connect(mapStateToProps)(HouseKeepingCharter);
